export default __webpack_public_path__ + "static/menu-fighter1-5681004a39ba092e62e3f490b4961a5e.png";